import React from 'react';
import { partners } from '../data/mockData';

export const TechnologyPartners = () => {
  // Duplicate partners array for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section id="partners" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1e3a8a] mb-4">
            Technology Partners
          </h2>
          <p className="text-lg text-gray-600">Authorized partners of leading global brands</p>
        </div>

        {/* Automatic sliding partner logos */}
        <div className="relative overflow-hidden">
          <div className="flex animate-scroll">
            {duplicatedPartners.map((partner, index) => (
              <div 
                key={`${partner.id}-${index}`} 
                className="flex-shrink-0 mx-8 flex items-center justify-center"
                style={{ width: '150px' }}
              >
                <div className="px-6 py-4 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow duration-300 w-full h-20 flex items-center justify-center">
                  <span className="text-lg font-semibold text-gray-700">{partner.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CSS for animation will be added via a style tag */}
        <style jsx>{`
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          
          .animate-scroll {
            animation: scroll 20s linear infinite;
          }
          
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}</style>
      </div>
    </section>
  );
};